import { Injectable } from '@angular/core';
import { Variable } from '../models/variable';
import { VariableListComparison } from '../models/variable-list-comparison';

@Injectable({
  providedIn: 'root'
})
export class VariableComparerService {
  private readonly added: string = 'added';
  private readonly deleted: string = 'deleted';
  private readonly edited: string = 'edited';
  private readonly unchanged: string = 'unchanged';

  constructor() { }

  compare(before: Variable[], after: Variable[]): VariableListComparison {
    before.forEach(v => v.status = this.unchanged);
    after.forEach(v => v.status = this.unchanged);

    const deletions = this.difference(before, after, (b, a) => b.name === a.name && b.scope === a.scope)
      .map(d => this.setStatus(d, this.deleted));
    const additions = this.difference(after, before, (a, b) => a.name === b.name && a.scope === b.scope)
      .map(a => this.setStatus(a, this.added));
    const editedBefore = this.intersect(before, after, (b, a) => b.name === a.name && b.scope === a.scope && b.value !== a.value)
      .map(e => this.setStatus(e, this.edited));
    const editedAfter = this.intersect(after, before, (a, b) => a.name === b.name && a.scope === b.scope && a.value !== b.value)
      .map(e => this.setStatus(e, this.edited));
    const unchanged = this.intersect(before, after, (b, a) => b.name === a.name && b.scope === a.scope && b.value === a.value);

    const result = new VariableListComparison([...deletions, ...editedBefore, ...unchanged], [...additions, ...editedAfter, ...unchanged]);

    return result;
  }

  setStatus(v: Variable, status: string): Variable {
    v.status = status;
    return v;
  }

  difference(listA: Variable[], listB: Variable[], predicate: (x: Variable, y: Variable) => boolean): Variable[] {
    return listA.filter(a => listB.filter(b => {
      return predicate(a, b);
    }).length === 0);
  }

  intersect(listA: Variable[], listB: Variable[], predicate: (x: Variable, y: Variable) => boolean): Variable[] {
    return listA.filter(a => listB.filter(b => {
      return predicate(a, b);
    }).length > 0);
  }
}
